// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const cnpj: CountryValidator<"BR"> = createValidator(
  "br.cnpj",
  26,
);

export default cnpj;
export const compact = cnpj.compact;
export const format = cnpj.format;
export const validate = cnpj.validate;
export const generate = (): string =>
  cnpj.generate?.() ??
  (() => {
    throw new Error(
      "Validator br.cnpj cannot generate values",
    );
  })();
